import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  span:nth-child(2) {
    font: var(--400-13);
  }

  > h3 {
    font: var(--600-16);
    margin-bottom: 8px;
  }
`
